import { render, staticRenderFns } from "./FormulaEditionBox.vue?vue&type=template&id=5492db83&lang=pug"
import script from "./FormulaEditionBox.vue?vue&type=script&lang=js"
export * from "./FormulaEditionBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports